import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { contact, location } from "../../Constant";

function Support() {
    return (
        <>
            <Header />
            <section
                className="servcies py-10"
                style={{ backgroundImage: `url(${contact})` }}
            >
                <div className="container hero supplement ">
                    <div className="row">
                        <div className="col-md-6 py-10">
                            <h1 className="white">Contact and Support</h1>
                            <p className="white">
                                We're only a click away. We'll be happy to help
                                you with any questions or concerns you might
                                have.
                            </p>
                        </div>
                        <div className="col-md-6"></div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container" style={{ padding: "40px" }}>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="contact-box border-right">
                                <h4 className="blue ">Office in Oregon</h4>
                                <ul className="list-unstyled ul-color">
                                    <li>
                                        <img
                                            src={location}
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            24023 NE Shea Ln, Unit #305 Wood
                                            Village, OR 97060
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="img/telephone.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            +(123) 456.789.10
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="img/smartphone.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            +(123) 456.789.10
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="img/email.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            oregon@myhomehelper.com
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="contact-box border-right">
                                <h4 className="blue">Office in Amsterdam</h4>
                                <ul className="list-unstyled ul-color">
                                    <li>
                                        <img
                                            src="img/location.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            24023 NE Shea Ln, Unit #305 Wood
                                            Village, OR 97060
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="img/telephone.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            +(123) 456.789.10
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="img/smartphone.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            +(123) 456.789.10
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="img/email.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            oregon@myhomehelper.com
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="contact-box border-right">
                                <h4 className="blue">Office in Barcelona</h4>
                                <ul className="list-unstyled ul-color">
                                    <li>
                                        <img
                                            src="img/location.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            24023 NE Shea Ln, Unit #305 Wood
                                            Village, OR 97060
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="img/telephone.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            +(123) 456.789.10
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="img/smartphone.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            +(123) 456.789.10
                                        </span>
                                    </li>
                                    <li>
                                        <img
                                            src="img/email.png"
                                            className="img-p"
                                            alt=""
                                        />
                                        <span className="padding-p">
                                            oregon@myhomehelper.com
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="google-map">
                                <a href="#" target="_blank">
                                    <img src="img/map.jpg" height="520" />
                                </a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="container form-1">
                                    <form
                                        id="ContactForm"
                                        className="form-signup"
                                        method="post"
                                        action=""
                                    >
                                        <div className="form-label-group">
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                id="contact-name"
                                                placeholder="Enter your name"
                                                required
                                                autofocus
                                            />
                                            <label htmlFor="label-name">
                                                YOUR NAME{" "}
                                                <span className="orange">
                                                    REQUIRED
                                                </span>
                                            </label>
                                        </div>
                                        <br />
                                        <div className="form-label-group">
                                            <input
                                                type="email"
                                                name="email"
                                                id="contact-email"
                                                className="form-control"
                                                placeholder="Your Email"
                                                required
                                                autofocus
                                            />
                                            <label htmlFor="label-email">
                                                YOUR EMAIL{" "}
                                                <span className="orange">
                                                    REQUIRED
                                                </span>
                                            </label>
                                        </div>
                                        <br />
                                        <div className="form-label-group">
                                            <textarea
                                                name="message"
                                                className="form-control"
                                                rows="3"
                                                id="contact-message"
                                                name="message"
                                                placeholder="YOUR MESSAGE"
                                                data-error="Write your message"
                                            ></textarea>
                                        </div>
                                        <br />
                                        <div className="checkbox mb-3 ">
                                            <label>
                                                <input
                                                    className="check-font"
                                                    name="check"
                                                    type="checkbox"
                                                    value="remember-me"
                                                    style={{
                                                        visibility: "hidden",
                                                    }}
                                                />{" "}
                                                <span
                                                    style={{
                                                        visibility: "hidden",
                                                    }}
                                                >
                                                    Save my name, email, and
                                                    website in this browser for
                                                    the next time I comment.
                                                </span>
                                            </label>
                                        </div>
                                        <button
                                            className="btn btn-submit"
                                            type="submit"
                                        >
                                            Submit
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default Support;
